// src/utils/appLinks.js
const PACKAGE_NAME = "com.showusshows.app";

export const PLAY_STORE_URL =
  `https://play.google.com/store/apps/details?id=${PACKAGE_NAME}`;

// Intent URL: if app is installed → open it,
// if not → Chrome uses browser_fallback_url (Play Store)
export const ANDROID_INTENT_URL =
  `intent://open#Intent;scheme=showusshows;package=${PACKAGE_NAME};` +
  `S.browser_fallback_url=${encodeURIComponent(PLAY_STORE_URL)};end`;
